import { css } from 'styled-components'
import { minMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'

const section = css`
  padding-top: 80px;

  ${minMq('MD')} {
    padding-top: 100px;
  }
`

const lastSection = css`
  margin-bottom: 120px;

  ${minMq('MD')} {
    margin-bottom: 150px;
  }
`

const buttons = css`
  display: grid;
  gap: 24px 34px;
  grid-auto-rows: 60px;
  grid-template-columns: repeat(auto-fit, 280px);

  ${minMq('MD')} {
    gap: 40px 50px;
    grid-auto-rows: 64px;
    grid-template-columns: repeat(auto-fit, 300px);
    justify-content: space-around;
  }
`

const button = (category: "toyama" | "niigata") => {
  const bgColor = category === "toyama" ? variables.LIGHT_BLUE : variables.SEAGREEN

  return css`
    background-color: ${bgColor};
    border-radius: 6px;
    color: ${variables.WHITE};
    display: grid;
    place-content: center;

    &.is-hover {
      opacity: .7;
      transition: opacity .6s;

      span {
        opacity: 1;
      }
    }
  `
}

const disabled = css`
  background-color: ${variables.GRAY} !important;
  cursor: default;
  pointer-events: none;
`

export const style = {
  section,
  lastSection,
  buttons,
  button,
  disabled
}